import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import {
  getOtherIcons,
  ZeeFontBold,
  ZeeFontMedium,
  ZeeFontRegular
} from 'src/styles/font';
import { OtherIconsSet } from 'src/utils/constants/IconsConstants';

export const setUpParentalPinPopup = css`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 1000;
  background: ${colors.PortalTransparentBg};
`;
export const setUpParentalPinPopupContent = css`
  background: ${colors.white};
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  max-width: 360px;
  max-height: 85%;
  margin: 0 auto;
  padding: 20px;
  border-radius: 6px;
  overflow: auto;
`;

export const setUpParentalPinWrap = css`
  max-width: 300px;
  margin: 0 auto;
`;

export const popupTitle = css`
  ${ZeeFontBold(18, 26)};
  color: ${colors.AccentDarkGrayColor};
  margin-bottom: 12px;
  text-align: center;
`;

export const popupDesc = css`
  ${ZeeFontMedium(14, 22)};
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
`;

export const incorrectPin = styled.div`
  ${ZeeFontRegular(11, 15)};
  margin-top: 10px;
  color: ${colors.AccentPromoCodeFailureColor};
  opacity: ${(props) => (props.className === 'show' ? `1` : `0`)};
`;

export const termsMsg = css`
  ${ZeeFontMedium(12, 18)};
  color: ${colors.Gray4F};
  margin: 20px 0 16px 0;
  padding-left: 32px;
  position: relative;
  display: block;
`;

export const popupBtn = styled.button`
  background-color: ${colors.PurpleBtn};
  border-radius: 6px;
  ${ZeeFontRegular(14, 20)};
  color: ${colors.white};
  height: 44px;
  width: 100%;
  max-width: 300px;
  opacity: ${(props) => (props.disabled ? `.5` : `1`)};
  cursor: ${(props) => (props.disabled ? `default` : `pointer`)};
`;

export const checkboxInput = css`
  display: none;
`;

export const checkboxMark = styled.span<{ checked: boolean }>`
  position: absolute;
  top: 3px;
  box-sizing: border-box;
  left: 0;
  height: 16px;
  width: 16px;
  border-radius: 3px;
  border: 1px solid ${colors.PurpleBtn};
  cursor: pointer;
  text-align: center;
  ${getOtherIcons(OtherIconsSet.TICK)};
  &:before {
    color: ${colors.white};
    position: absolute;
    left: 0;
    height: 100%;
    width: 100%;
    ${(props) => props.checked && `background-color:  ${colors.PurpleBtn};`}
    ${(props) => !props.checked && `display: none;`}
  }
`;

export const pinWrap = css``;
export const popupSubTitle = css`
  ${ZeeFontMedium(14, 24)};
  color: ${colors.ComboPopupSubtitleGray};
  margin-top: 32px;
  margin-bottom: 16px;
`;
